import React, { useEffect, useState } from "react";
import { Button } from "./ui/button";
import axios from "axios";
import ComprehensiveFormV2 from "./ComprehensiveFormV2";
import normalizeExtraction from "../utils/normalizeExtraction";
import { Portal } from "@radix-ui/react-portal";

export default function BulkReviewDrawer({ open, onClose, app, markReviewed }) {
  const [loading, setLoading] = useState(true);
  const [info, setInfo] = useState({});   // <= this feeds ComprehensiveFormV2

  useEffect(() => {
    if (open && app?.id) {
      document.body.style.overflow = "hidden";
      loadApplication(app.id);
    } else {
      document.body.style.overflow = "";
      setInfo({});
    }
    return () => (document.body.style.overflow = "");
  }, [open, app]);

  const loadApplication = async (applicationId) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/applications/${applicationId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // Prefer DB-saved fields; else intake mapping
      const raw =
        res.data?.extracted_fields ||
        res.data?.extracted?.mapped ||
        {};

      // Normalize to the exact snake_case keys your form expects
      const normalized = normalizeExtraction(raw);
      setInfo(normalized);
    } catch (e) {
      console.error("Failed to load application", e);
    } finally {
      setLoading(false);
    }
  };

  // called by the form for every change
  const updateField = (key, value) => {
    setInfo((prev) => ({ ...prev, [key]: value }));
  };

  const handleMarkReviewed = async () => {
    // OPTIONAL: persist edited info back to DB
    // const token = localStorage.getItem("token");
    // await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/applications/${app.id}`, 
    //   { extracted_fields: info }, 
    //   { headers: { Authorization: `Bearer ${token}` } }
    // );

    markReviewed(app.id);
    onClose();
  };

  if (!open || !app) return null;

  return (
    <Portal>  {/* ✅ allows dropdowns to escape drawer */}
      <div className="fixed inset-0 z-[9999]">
        
        {/* Overlay */}
        <div
          className="absolute inset-0 bg-black/40 backdrop-blur-sm"
          onClick={onClose}
        />
  
        {/* Drawer Panel */}
        <div
          className="absolute right-0 top-0 h-full w-full md:w-1/2 bg-white shadow-2xl border-l border-gray-200 flex flex-col animate-[slideLeft_.25s_ease-out]"
          style={{ overflow: "visible" }}    // ✅ ensures dropdowns are visible
        >
          
          {/* Header */}
          <div className="p-4 border-b border-gray-200 flex items-center justify-between bg-white">
            <div>
              <h3 className="text-lg font-semibold text-gray-900">Review Application</h3>
              <p className="text-sm text-gray-600">
                {(app.applicant_name || app.passengers?.[0]?.full_name || "Unknown Applicant")}
                {" "}• ID: {app.id}
              </p>
            </div>
  
            <div className="flex items-center gap-2">
              <Button variant="outline" onClick={onClose}>Close</Button>
              <Button className="bg-green-600 hover:bg-green-700 text-white" onClick={handleMarkReviewed}>
                Mark Reviewed ✓
              </Button>
            </div>
          </div>
  
          {/* Body */}
          <div className="flex-1 overflow-y-auto p-5">
            {loading ? (
              <div className="text-center text-gray-500 py-10">Loading…</div>
            ) : (
              <ComprehensiveFormV2 info={info} updateField={updateField} />
            )}
          </div>
  
        </div>
      </div>
    </Portal>
  );
}